const PauseSvg = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
            <circle cx="7" cy="7" r="6.4" stroke="#546EDB" strokeWidth="1.2"/>
            <path fill="#546EDB" fillRule="evenodd" stroke="#546EDB" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".5" d="M5.375 4c.207 0 .375.144.375.321V9.68c0 .177-.168.321-.375.321S5 9.856 5 9.679V4.32C5 4.144 5.168 4 5.375 4Zm3.25 0c.207 0 .375.144.375.321V9.68c0 .177-.168.321-.375.321s-.375-.144-.375-.321V4.32c0-.177.168-.321.375-.321Z" clipRule="evenodd"/>
        </svg>
    )
}

export default PauseSvg;